<template>
  <div class="sidebar-menu-nav w-full overflow-hidden">
    <div class="w-2/1 relative">
      <ul class="sidebar-menu-nav__list w-1/2 pl-6">
        <div v-for="(item, index) in menu" :key="'item' + index">
          <template v-if="!item.isAdmin || item.isAdmin === isAdmin">
            <h1 class="block py-2 text-gray-600 text-lg my-2">
              {{ item.name }}
            </h1>
            <router-link
              v-for="(subItem, subItemIndex) in item.submenu"
              :key="'subitem' + subItemIndex"
              :class="[{ 'route-active': isActive(subItem) }]"
              :to="getUrl(subItem.url)"
            >
              <li
                class="sidebar-menu-nav__item text-gray-600 hover:bg-gray-800 px-2 py-1 transition-colors duration-300"
                style="font-size: 12px;"
              >
                {{ subItem.name }}
              </li>
            </router-link>
          </template>
        </div>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarMenuNav',
  props: {
    menu: {
      type: Array,
      default: () => [],
    },

    parent: {
      type: Object,
      default: () => {},
    },

    rootName: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {}
  },

  computed: {
    isAdmin() {
      return this.$store.getters['user/isAdmin']
    },
  },

  methods: {
    isActive(item) {
      const itemUrl = this.getUrl(item.url)
      if (itemUrl.name !== 'Folders' || this.$route.name !== 'Folders') {
        return itemUrl.name === this.$route.name
      } else {
        const status = this.$route.query.status
        const itemStatus = itemUrl.query.status
        return status === itemStatus
      }
    },

    getUrl(url) {
      if (typeof url === 'function') {
        return url.call(this, this.$route)
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.route-active li {
  @apply text-white;
}
</style>
